export const statusTranslations = {
  // Lead requests статусы
  received: 'Отримана',
  contacted: 'Контакт встановлено',
  closed: 'Закрита',

  // Placement test сессии статусы
  in_progress: 'В процесі',
  awaiting_contact: 'Очікування контакту',
  completed: 'Завершена',
};

export function translateStatus(status) {
  return statusTranslations[status] || status;
}

export function getStatusColor(status) {
  const completedStatuses = ['completed', 'contacted', 'closed'];
  const inProgressStatuses = ['in_progress', 'received'];

  if (completedStatuses.includes(status)) {
    return { background: '#EAF6EA', color: '#2C5140', border: '#2D9E6B' };
  }

  if (inProgressStatuses.includes(status)) {
    return { background: '#FFF3CD', color: '#856404', border: '#FFE8A8' };
  }

  return { background: '#FFE8E8', color: '#FE0707', border: '#FE0707' };
}
